import React, { MouseEvent } from 'react';
import { IconButton } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import ModuleCard from 'components/module-card/ModuleCard';
import { Surgerie } from 'types/surgerie';
import { useReportSurgerie } from '../../hooks/useReportSurgerie';

interface ReportSurgerieItemModuleProps {
  surgerie: Surgerie;
}

function getStatusTone(status: string) {
  if (status === 'open') return 'info';
  if (status === 'closed') return 'success';
  if (status === 'deleted') return 'error';
  return 'default';
}

const ReportSurgerieItemModule: React.FC<ReportSurgerieItemModuleProps> = ({ surgerie }) => {
  const { setAnchorEl, setSelectedSurgerie } = useReportSurgerie();

  function handleActionClick(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedSurgerie(surgerie);
  }

  return (
    <ModuleCard
      idLabel={`Orçamento #${surgerie.id_int || surgerie.id}`}
      title={surgerie.formattedPatientName}
      subtitle={surgerie.formattedProcedureName}
      status={surgerie.formattedStatus}
      statusTone={getStatusTone(surgerie.status)}
      actions={
        <IconButton size="small" color="default" onClick={handleActionClick}>
          <MoreHoriz fontSize="small" />
        </IconButton>
      }
      fields={[
        { label: 'Criado em', value: surgerie.formattedCreatedAt },
        { label: 'Fechado em', value: surgerie.formattedClosedAt },
        { label: 'Fechado por', value: surgerie.closed_by },
        { label: 'Médico', value: surgerie.formattedDoctorName },
        { label: 'Hospital', value: surgerie.formattedHospitalName },
        { label: 'Procedimento', value: surgerie.formattedProcedureName, fullWidth: true },
      ]}
      metrics={[
        { label: 'Entrada', value: surgerie.formattedValueEntry },
        { label: 'Pago', value: surgerie.formattedValuePaid, tone: 'success' },
        { label: 'Total', value: surgerie.formattedTotalValue, tone: 'primary' },
      ]}
    />
  );
};

export default ReportSurgerieItemModule;
